import React from "react";
import { Button } from "react-bootstrap";

const AirbnbConnect = () => {
  const handleClick = () => {
    const clientId = "40qx7vz9ylf1b2htzilwu1ek";
    const scope = "property_management,messages_read,messages_write";
    const redirectUri = "https://cmapi.stayflexi.com/cm/api/airbnb/redirect/";
    const authUrl = `https://www.airbnb.com/oauth2/auth?client_id=${clientId}&response_type=code&scope=${scope}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}`;

    // Open in a new tab
    window.open(authUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div style={{ marginLeft: "2rem" }}>
      <Button
        variant="success"
        size="lg"
        className="w-100"
        onClick={handleClick}
      >
        Connect with Airbnb
      </Button>
    </div>
  );
};

export default AirbnbConnect;
